import { WEB_PLAYER_CONTEXT_MENUS } from './available-context-menus';
var ɵ0 = WEB_PLAYER_CONTEXT_MENUS;
var WebPlayerModule = /** @class */ (function () {
    function WebPlayerModule() {
    }
    return WebPlayerModule;
}());
export { WebPlayerModule };
export { ɵ0 };
